import { differenceInMilliseconds, endOfDay, startOfDay } from "date-fns";

export const isAllDayLong: IsAllDayLong = (from, to) =>
  differenceInMilliseconds(startOfDay(from), from) < 1000
  && differenceInMilliseconds(endOfDay(to), to) < 1000;

type IsAllDayLong = (from: Date, to: Date) => boolean;